import { render } from "./ReturnSendProductPanel.vue?vue&type=template&id=c94b2510&scoped=true&ts=true"
import script from "./ReturnSendProductPanel.vue?vue&type=script&lang=ts"
export * from "./ReturnSendProductPanel.vue?vue&type=script&lang=ts"

import "./ReturnSendProductPanel.vue?vue&type=style&index=0&id=c94b2510&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c94b2510"]])

export default __exports__